<app-telephony-comparison-calls-subheader
  [(period)]="period"
  [(directionIds)]="directionIds"
  [(salesTeamIds)]="salesTeamIds"
  [(salesPersonIds)]="salesPersonIds"
  (queryChange)="onQueryChange($event)"
/>

<div>
  <div class="details-content container-fluid h-100">
    <div class="row h-100">
      <div class="col-content d-flex flex-column h-100">
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                @if (callsData$ | async; as callsData) {
                  <div class="row mt-2">
                    <div class="col-12 col-md">
                      <app-generic-grid
                        style="height: 500px"
                        [data]="callsData"
                        [tabViewName]="'callsPerformanceReport'"
                        [pageSize]="999"
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
